<form-control-container
  #container
  [control]="controlInstance"
  [class.readonly]="isReadonlyValue"
>
  <div label-extension>
    <ng-content select="[label-extension]"></ng-content>
  </div>

  <ng-container *ngIf="!isReadonlyValue">
    <div class="input-group">
      <ng-content select="[before]"></ng-content>
      <div
        ngbDropdown
        #dropDown
        class="d-inline-block input-container"
        autoClose="outside"
      >
        <input
          ngbDropdownToggle
          type="text"
          [id]="controlId"
          #input
          [attr.name]="inputName"
          class="form-control"
          [maskito]="maskitoOptions"
          [ngClass]="{ invalid: invalid }"
          [value]="displayValue"
          (input)="onInputChange($event)"
          (focusout)="onInputFocusedOut()"
          (click)="onInputClicked($event)"
          [autocomplete]="autocomplete ? 'on' : 'off'"
          [attr.tabindex]="tabindex"
          [attr.placeholder]="placeholder"
          [disabled]="disabled"
          [readOnly]="!allowTyping"
        />

        <div
          ngbDropdownMenu
          [class.show-only-months]="showOnlyMonths"
          [attr.aria-labelledby]="controlId"
        >
          <div class="dropdown-item">
            <ngb-datepicker
              *ngIf="!showOnlyMonths"
              #datepicker
              [ngModel]="ngbDateModel"
              (dateSelect)="onSelectDate($event)"
              [dayTemplate]="customDay"
              [firstDayOfWeek]="firstDayOfWeek"
              [minDate]="ngbMinDate"
              [maxDate]="ngbMaxDate"
              [showWeekDays]="true"
              [startDate]="startDate"
            >
            </ngb-datepicker>
            <month-view
              *ngIf="showOnlyMonths"
              [(model)]="ngbDateModel"
              (modelChange)="onSelectMonth()"
            >
            </month-view>
          </div>
        </div>
      </div>
      <ng-content select="[after]"></ng-content>

      <ng-template
        #customDay
        let-date
        let-currentMonth="currentMonth"
        let-selected="selected"
        let-textMuted="texMuted"
        let-disabled="disabled"
        let-focused="focused"
      >
        <div
          class="btn-light custom-day"
          [class.bg-primary]="
            ngbDateModel &&
            date.day == ngbDateModel.day &&
            date.month == ngbDateModel.month &&
            date.year == ngbDateModel.year
          "
          [class.today]="
            date.day == today.day &&
            date.month == today.month &&
            date.year == today.year
          "
          [class.focused]="focused"
          [class.text-muted]="textMuted"
          [class.disabled]="disabled"
          [class.outside]="date.month !== currentMonth"
          ngbDatepickerDayView
        >
          {{ date.day }}
        </div>
      </ng-template>
    </div>
  </ng-container>

  <ng-container *ngIf="isReadonlyValue">
    <span class="readonly-value">{{ displayValue }}</span>
  </ng-container>
</form-control-container>
